import React from 'react';
import PropTypes from 'prop-types';
import TabFetchProvider from '../shared/providers/TabFetchProvider';
import Form from './form/Form';
import Progeny from './progeny/Progeny';
import { hasProgeny } from '../utils/horse';
import WeatherbysOverview from './weatherbysOverview/WeatherbysOverview';

const routes = {
    form: {
        Tab: Form,
        fetchPath: 'form',
    },
    progeny: {
        Tab: Progeny,
        fetchPath: 'progeny',
    },
    weatherbysOverview: {
        Tab: WeatherbysOverview,
        fetchPath: 'weatherbys-overview',
    },
};

const IndexTab = (props) => {
    const { profile } = props.data;

    if (profile.weatherbysUid) {
        const route = routes.weatherbysOverview;
        return <TabFetchProvider {...props} route={route} />;
    }

    const route = hasProgeny(profile) ? routes.progeny : routes.form;
    return <TabFetchProvider {...props} route={route} />;
};

IndexTab.propTypes = {
    data: PropTypes.shape({
        profile: PropTypes.shape({
            damStatus: PropTypes.bool,
            sireStatus: PropTypes.bool,
            weatherbysUid: PropTypes.string,
        }),
    }),
};

IndexTab.displayName = 'IndexTab';

export default IndexTab;



// WEBPACK FOOTER //
// ./src/js/horse/IndexTab.jsx